import { render } from "./TestResultAssteacher.vue?vue&type=template&id=294e10ec&scoped=true"
import script from "./TestResultAssteacher.vue?vue&type=script&lang=js"
export * from "./TestResultAssteacher.vue?vue&type=script&lang=js"

import "./TestResultAssteacher.vue?vue&type=style&index=0&id=294e10ec&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294e10ec"]])

export default __exports__